export default __webpack_public_path__ + "static/media/35t.60e2d6a4.jpg";